import { render, staticRenderFns } from "./DeptTreeSelect.vue?vue&type=template&id=18f83baf&scoped=true&"
import script from "./DeptTreeSelect.vue?vue&type=script&lang=js&"
export * from "./DeptTreeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f83baf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f83baf')) {
      api.createRecord('18f83baf', component.options)
    } else {
      api.reload('18f83baf', component.options)
    }
    module.hot.accept("./DeptTreeSelect.vue?vue&type=template&id=18f83baf&scoped=true&", function () {
      api.rerender('18f83baf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/components/DeptTreeSelect.vue"
export default component.exports